import toastr from 'toastr';

export const Thumbnail = {
  state: {
    keyImages: [],
    removedImages: [],
    newImages: [],
    busy: 0,
  },

  getters: {
    getKeyImages: (state) => (parentCase) => {
      const keyImages = state.keyImages.filter(({ originCase }) => originCase?.id === parentCase.id);

      const caseImages = keyImages
        .filter((image) => !image.originReply)
        .sort((a, b) => (a.position === b.position ? 0 : a.position < b.position ? -1 : 1));

      const replyImages = keyImages
        .filter((image) => !!image.originReply)
        .sort((a, b) => (a.originReply.id < b.originReply.id ? -1 : a.reference < b.reference ? -1 : 1));

      return caseImages.concat(replyImages);
    },

    getRemovedImages: (state) => (parentCase) => {
      return state.removedImages
        .filter(({ originCase }) => originCase?.id === parentCase.id)
        .concat()
        .sort((a, b) => (a.id < b.id ? -1 : 1));
    },

    getNewImages: (state) => (parentCase) => {
      return state.newImages
        .filter(({ originCase }) => originCase?.id === parentCase.id)
        .concat()
        .sort((a, b) => (a.id < b.id ? 1 : -1));
    },

    getReplyImages: (state, getters) => (parentReply) => {
      return getters
        .getKeyImages(parentReply.originCase)
        .filter(({ originReply }) => originReply?.id === parentReply.id);
    },

    isBusy: (state) => {
      return state.busy > 0;
    },
  },

  mutations: {
    addKeyImage(state, image) {
      state.removedImages = state.removedImages.filter(({ id }) => image.id !== id);
      state.newImages = state.newImages.filter(({ id }) => image.id !== id);
      state.keyImages = state.keyImages.filter(({ id }) => image.id !== id);
      state.keyImages.push(image);
    },

    addRemovedImage(state, image) {
      state.removedImages = state.removedImages.filter(({ id }) => image.id !== id);
      state.removedImages.push(image);

      state.keyImages = state.keyImages.filter(({ id }) => image.id !== id);
    },

    addNewImage(state, image) {
      state.newImages = state.newImages.filter(({ id }) => image.id !== id);
      state.newImages.push(image);
    },

    setBusy(state, value) {
      state.busy += value ? 1 : -1;
    },
  },

  actions: {
    importImages({ dispatch, commit, getters }, originCase) {
      if (getters.isBusy) {
        return Promise.reject('Thumbnail store is busy');
      }

      commit('setBusy', true);

      return this._vm
        .$api('cases.thumbnails.import', ['1.0', originCase])
        .then(async () => {
          dispatch('getKeyImages', originCase);
          dispatch('getNewImages', originCase);
          dispatch('getRemovedImages', originCase);
        })
        .catch(() => toastr.error('Failed importing images'))
        .finally(() => commit('setBusy', false));
    },

    getKeyImages({ commit }, originCase) {
      commit('setBusy', true);

      return this._vm
        .$api('cases.thumbnails.index', ['1.0', originCase])
        .then((response) => {
          const images = response.data.data;
          images.forEach((image) => commit('addKeyImage', image));
        })
        .catch(() => {})
        .finally(() => commit('setBusy', false));
    },

    getNewImages({ commit }, originCase) {
      commit('setBusy', true);

      return this._vm
        .$api('cases.thumbnails.new', ['1.0', originCase])
        .then((response) => {
          const images = response.data.data;
          images.forEach((image) => commit('addNewImage', image));
        })
        .catch(() => {})
        .finally(() => commit('setBusy', false));
    },

    getRemovedImages({ commit }, originCase) {
      commit('setBusy', true);

      return this._vm
        .$api('cases.thumbnails.removed', ['1.0', originCase])
        .then((response) => {
          const images = response.data.data;
          images.forEach((image) => commit('addRemovedImage', image));
        })
        .catch(() => {})
        .finally(() => commit('setBusy', false));
    },
  },
};
